export default __webpack_public_path__ + "static/media/plush.f62ff079.webp";